"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _Select = _interopRequireDefault(require("./Select.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Select = function Select(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    id = _ref.id,
    identifier = _ref.identifier,
    label = _ref.label,
    _onChange = _ref.onChange;
  var css = (0, _Select.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.select, "mco-shop-select")
  }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    classes: {
      label: css.label
    },
    control: /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: checked,
      color: "primary",
      name: "shippingProvider",
      onChange: function onChange() {
        return _onChange(id);
      }
    }),
    label: label
  }), identifier && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    className: (0, _clsx.default)(css.icon, "mco-shop-select__icon"),
    color: "initial",
    src: "/img/icons/shop/".concat(identifier, ".svg"),
    size: 20
  }));
};
var _default = Select;
exports.default = _default;